<template>
  <div :class="`hard-detail-wrap${$theme?'':' eng'}`">
    <div class="hard-detail">
      <main :style="{transform: 'scale('+(multiple<1?multiple:1)+')'}">
<!--        <i class="el-icon-close close" @click="close"></i>-->
        <div class="close" @click="close"><i class="el-icon-close"></i></div>
        <div class="hard-detail-left">
          <div class="title">{{ $theme ? obj.title : obj.titleEng }}</div>
          <div class="content">
            <div v-if="$theme" class="back-text">{{ $theme ? obj.title : obj.titleEng }}</div>
            <div ref="viewer" id="viewer" class="viewer" @mousemove="onMousemove" @mouseleave="onMouseleave">
              <div class="circle" :style="{top: top+'px',left: left+'px'}"></div>
            </div>
          </div>
        </div>
        <div class="hard-detail-right">
          <div class="title">
            <!--          {{ $theme ? obj.parentName : obj.parentNameEng }}-->
            {{ $theme ? '产品概述' : 'Product overview' }}
          </div>
          <div class="desc">
            {{ $theme ? obj.overview : obj.overviewEng }}
          </div>
          <div class="title">
            {{ $theme ? '功能特点' : 'Functional characteristics' }}
          </div>
          <div :class="`row${$theme?'':' eng'}`">
            <div
                @mouseenter="activeFunc = item.id"
                :class="{ 'active-list': activeFunc === item.id }"
                class="list-item"
                v-for="item in funcs"
                :key="item.id"
                :style="{width:getWidth()+'px',left: activeFunc < item.id ? item.activeLeft : item.left}"
            >
              <div class="title-wrap">
                <div :class="`${$theme?'chn-title':'eng-title'}`">{{ item.title }}</div>
              </div>
              <div class="desc">
                <div v-if="!$theme" class="desc-title">{{ item.title }}</div>
                {{ item.desc }}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import {getHardwareDetail} from "@/api/product";
import * as THREE from "three"
import {GLTFLoader} from 'three/examples/jsm//loaders/GLTFLoader.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import map from "../../product-center/model.js";

export default {
  name: "HardDetail",
  components: {},
  props: {
    obj: {
      type: Object,
      default() {
        return {
          title: ''
        }
      }
    }
  },
  data() {
    return {
      title: null,
      top: -80,
      left: -80,
      activeFunc: 1,
      funcs: [],
      arr: [],
      map,
      multiple: 1
    };
  },
  computed: {},
  created() {
    // this.obj = JSON.parse(sessionStorage.getItem("hard")).find(({code}) => code === this.$route.params.typeCode).children.find(({code}) => code === this.$route.params.code)
  },
  watch: {},
  mounted() {
    window.addEventListener('resize', this.onWindowResize, false)
    this.$nextTick(() => {
      this.onWindowResize()
    })
    const functionList = this.$theme ? this.obj.function : this.obj.functionEng
    this.arr = functionList.split('\r\n').slice(0, 5)
    this.arr.map((item, index) => {
      this.funcs.push({
        id: index + 1,
        title: item.split(this.$theme ? '：' : ':')[0],
        desc: item.split(this.$theme ? '：' : ':')[1],
        left: index * 90 + "px",
        // activeLeft: (index === 0 ? 0 : (index - 1) * 90 + 521) + "px"
        activeLeft: (index === 0 ? 0 : (index - 1) * 90 + this.getWidth()) + "px"
      });
    });
    this.init()
  },
  methods: {
    getWidth() {
      const {length} = this.arr
      if (length < 5) {
        return 521
      }
      return 521 - (length - 4) * 90
    },
    onWindowResize() {
      const width = document.body.clientWidth;
      this.multiple = width / 1920
      if (!this.scene) {
        return
      }
      const viewer = this.$refs.viewer
      this.renderer.setSize(viewer.clientWidth, viewer.clientHeight)
      this.camera.aspect = viewer.clientWidth / viewer.clientHeight
      this.camera.updateProjectionMatrix()
    },
    onMousemove(e) {
      this.left = e.offsetX
      this.top = e.offsetY
    },
    onMouseleave() {
      this.top = -80
      this.left = -80
    },
    init() {
      this.initScene()
    },
    initScene() {
      // 初始化场景
      const viewer = this.$refs.viewer
      const scene = new THREE.Scene();

      const light = new THREE.AmbientLight(0xffffff, 1);
      scene.add(light);
      const sunlight = new THREE.DirectionalLight(0xffffff, this.map[this.obj.title]?.intensity || 1.5);
      const position = this.map[this.obj.title]?.position || [-20, 5, 5]
      sunlight.position.set(position[0], position[1], position[2]);
      scene.add(sunlight);
      this.sunlight = sunlight
      const camera = new THREE.PerspectiveCamera(75, viewer.clientWidth / viewer.clientHeight, 0.1, 10000);
      camera.position.set(0, 0, 50);

      const renderer = new THREE.WebGLRenderer();
      renderer.setSize(viewer.clientWidth, viewer.clientHeight);
      renderer.setClearColor(0x0a0a0a, 0);
      renderer.outputEncoding = THREE.sRGBEncoding;
      this.renderer = renderer
      viewer.appendChild(renderer.domElement);

      const controls = new OrbitControls(camera, renderer.domElement);
      controls.enableDamping = true
      controls.dampingFactor = 0.2
      controls.enablePan = false
      controls.enableZoom = false

      function animate() {
        requestAnimationFrame(animate);
        renderer.render(scene, camera);
        controls.update();
      }

      animate();
      this.scene = scene
      this.camera = camera
      this.initialPosition = camera.position.clone();
      this.initialQuaternion = camera.quaternion.clone();
      this.addModel()
    },
    addModel() {
      const {scene, camera} = this
      camera.position.copy(this.initialPosition);
      camera.quaternion.copy(this.initialQuaternion);
      if (this.model) {
        scene.remove(this.model)
      }
      const loader = new GLTFLoader();
      loader.load(
          `/model/product/${this.obj.title}.glb`,
          (gltf) => {
            const model = gltf.scene
            const y = this.map[this.obj.title]?.y || -15
            const scale = this.map[this.obj.title]?.scale * 0.9 || 45
            const rotation = this.map[this.obj.title]?.rotation || [0, -Math.PI / 6, 0]
            model.scale.set(scale, scale, scale)
            model.rotation.set(rotation[0], rotation[1], rotation[2])
            model.position.set(0, y + 3, 0)
            // 递归遍历所有模型节点批量修改材质
            model.traverse((obj) => {
              if (obj.isMesh) { // 判断是否是网格模型
                obj.material.metalness = this.map[this.obj.title]?.metalness || 0.5
              }
            });
            scene.add(model)
            this.model = model
          }
      );
    },
    close() {
      this.scene.remove(this.model)
      this.model = null
      this.scene = null
      this.$emit('close')
    },
    getHardwareDetail(code) {
      getHardwareDetail({code: code})
          .then(res => {
            if (res.code == 200) {
              let data = res.data[0];
              this.title = data.title;
              this.photo = data.photo;
              this.overview = data.overview;
              this.functionTitles = [];
              this.functionTexts = [];
              data.function.split('\r\n').map(item => {
                this.functionTitles.push(item.split('：')[0]);
                this.functionTexts.push(item.split('：')[1]);
              });
              console.log(this.functionTitles, this.functionTexts);
            }
          })
          .catch(err => {
            console.log(err);
            this.title = '获取产品数据失败';
            this.$message.error('获取产品数据失败');
          });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "Index";
</style>
